// import React from "react";
// const number = [];
var myAssociate = [];
for (var i = 1; i <= 30; i++) {
  var newElement = {};
  newElement["id"] = i;
  newElement["num"] = i;
  myAssociate.push(newElement);
}
export const numbers = myAssociate;
